/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//Home Page
const greeting = {
  title: "Ghanshyam Chodavadiya",
  logo_name: "Ghanshyam Chodavadiya",
  nickname: "Machine Learning Engineer",
  subTitle:
    "I work on products which comprise neural networks that solve NLP and Computer Vision problems. This includes dataset gathering, neural network training, the science of making it work, and their deployment in production.",
  resumeLink:
    "https://drive.google.com/file/d/1rF7fqAgJf2Br_eM_gwjMS3EcLiXJjTc5/view?usp=sharing",
  portfolio_repository: "https://github.com/CG1507",
};

const socialMediaLinks = [
	/* Your Social Media Link */
	// github: "https://github.com/ashutosh1919",
	// linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
	// gmail: "ashutoshhathidara98@gmail.com",
	// gitlab: "https://gitlab.com/ashutoshhathidara98",
	// facebook: "https://www.facebook.com/laymanbrother.19/",
	// twitter: "https://twitter.com/ashutosh_1919",
	// instagram: "https://www.instagram.com/layman_brother/"
  
	{
		name: "Github",
		link: "https://github.com/CG1507",
		fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
		backgroundColor: '#181717' // Reference https://simpleicons.org/?q=github
	},
	{
		name: "LinkedIn",
		link: "https://www.linkedin.com/in/cg1507/",
		fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
		backgroundColor: '#0077B5' // Reference https://simpleicons.org/?q=linkedin
	},
	{
		name: "Gmail",
		link: "mailto:g8ghanshym@gmail.com",
		fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
		backgroundColor: '#D14836' // Reference https://simpleicons.org/?q=gmail
	},
	{
		name: "Twitter",
		link: "https://twitter.com/g8ghanshym",
		fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
		backgroundColor: '#1DA1F2' // Reference https://simpleicons.org/?q=twitter
	},
];

const skills = {
  data: [
    {
      title: "Data Science & ML/DL",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Structured, Semi-Structured, and Unstructured data 📝 crunch and visualization from Dataset gathering to serving it.",
        "⚡ Experienced in the AI-driven 🤖 product development cycle.",
        "⚡ Create/Manage Data Processing Pipeline 🎢 and Deep Learning Infrastructure for the product.",
        "⚡ Build, Train, Evaluate, and Test the Machine Learning Models in Tensorflow, Keras, Pytorch, and similar libraries & framework.",
        "⚡ Design NLP and Computer-Vision based deep learning models' architecture with critical details.",
        "⚡ Experienced in working with real-time, gigantic data. 🏭",
        "⚡ Transform the latest research (SOTA) in AI into the product."
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Science behind AI",
      fileName: "FullStackImg",
      skills: [
        "🎨 Apply mathematics to create neural networks that can work as an inspired system. Yes, I do write code for all matrix manipulation.",
        "🚼 Do babysitting of machine learning models till it becomes production-ready.",
        "🚃 I do write code for training models with multiple GPUs, hyperparameter search, babysitting of training, inference, model profiling, model debugging, optimize for hardware.",
      ],
      softwareSkills: [
        {
          skillName: "Math",
          fontAwesomeClassname: "carbon:math-curve",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "GPUs",
          fontAwesomeClassname: "carbon:virtual-machine",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Matrix Manipulation",
          fontAwesomeClassname: "cib:matrix",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "Model Debugger",
          fontAwesomeClassname: "codicon:debug",
          style: {
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Neural Network",
          fontAwesomeClassname: "carbon:network-4",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Model Profiling",
          fontAwesomeClassname: "carbon:user-profile-alt",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Hyperparameter Search",
          fontAwesomeClassname: "codicon:symbol-parameter",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Model Training",
          fontAwesomeClassname: "ic:baseline-model-training",
          style: {
            color: "#2C8EBB",
          },
        },
      ],
    },
    {
      title: "Backend & Cloud",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Create backend for Machine Learning models to serve in a highly scalable environment.",
        "⚡ Manage all databases or additional support to create the backend of the product that also comprises machine learning models.",
        "⚡ Deploy backend on cloud services with multi GPUs in a highly optimized way.",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "ElasticSearch",
          fontAwesomeClassname: "logos:elasticsearch",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "Redis",
          fontAwesomeClassname: "logos:redis",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "cib:flask",
          style: {
            color: "#FF2BC2",
          },
        },  
      ],
    },
    {
      title: "AI Infrastructure",
      fileName: "DesignImg",
      skills: [
        "⚡ Create CI/CD infrastructure development for machine learning engineers to train, test, and fluidly deploy the models.",
        "⚡ An Infrastructure that can monitor model performance, the model bias in inference, and version control of the models.",
        "⚡ Plug and play of models and backend configuration with slack and similar services to control the production setup without touching the code."
      ],
      softwareSkills: [
        {
          skillName: "Jenkins",
          fontAwesomeClassname: "logos:jenkins",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
        {
          skillName: "slack",
          fontAwesomeClassname: "logos:slack",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Bash",
          fontAwesomeClassname: "simple-icons:gnubash",
          style: {
            color: "#FF7C00",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "StackOverflow",
      iconifyClassname: "logos:stackoverflow-icon",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "https://stackoverflow.com/users/9138610/ghanshyam-chodavadiya",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@g8ghanshym",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/ghanshyam15",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/g8ghanshym",
    },
    {
      siteName: "Medium",
      iconifyClassname: "ant-design:medium-circle-filled",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://medium.com/@g8ghanshym",
    },
    {
      siteName: "Deep Learning Notes",
      iconifyClassname: "uil:clipboard-notes",
      style: {
        color: "#FF7C00",
      },
      profileLink: "https://drive.google.com/open?id=0B-kPpJKS_9ekWk5TbGxzT0c2aUU",
    },
    {
      siteName: "Machine Learning Notes",
      iconifyClassname: "cil:notes",
      style: {
        color: "#1488C6",
      },
      profileLink: "https://drive.google.com/open?id=0B-kPpJKS_9ekNWFSaTJWTThUN2M",
    },
    {
      siteName: "NLP Paper Notes",
      iconifyClassname: "ic:baseline-speaker-notes",
      style: {
        color: "#CB3837",
      },
      profileLink: "https://drive.google.com/open?id=1RyChNkc_qWHJUbqMJRWR5vA75M5SSVRV",
    },
    {
      siteName: "Paper Notes",
      iconifyClassname: "uil:clipboard-notes",
      style: {
        color: "#47A248",
      },
      profileLink: "https://drive.google.com/open?id=1_ZBSQHfkckFaLrTnjWj2vt-Y9I_1h86O",
    },
    {
      siteName: "Phrase Extraction Notes",
      iconifyClassname: "foundation:clipboard-notes",
      style: {
        color: "#F24E1E",
      },
      profileLink: "https://drive.google.com/open?id=17727_i9txKTWVrYfOsTa6xtTwizTZKWB",
    },
    {
      siteName: "Word Embeddings Notes",
      iconifyClassname: "uil:clipboard-notes",
      style: {
        color: "#326CE5",
      },
      profileLink: "https://drive.google.com/open?id=1K_phGBNfpZ0eN6i9h2Ps6kgnAXjXBg4S",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Gujarat Technological University",
      subtitle: "Bachelor of Engineering in Computer Science",
      logo_path: "Gujarat-Technological-University-Logo.png",
      alt_name: "GTU",
      duration: "May 2014 - June 2018",
      descriptions: [
        "⚡ I've learned the basic fundamentals of Engineering and Computer Science like DS, Algorithms, DBMS, OS, etc.",
        "⚡ Apart from this, I have done courses on Data Science, Machine Learning, and Deep Learning.",
        "⚡ In the final year, I got many opportunities to share my learning and knowledge through guest lectures and talks.",
        "⚡ Got 1st prize in Tech-Expo, 2018 at Parul University.",
        "⚡ Awarded for academic excellence by “Shree Devang Mehta IT Award” in 2015, 2016, and 2017.",
        "⚡ Mentored many M.tech students in Machine learning based thesis work.",
        ""
      ],
      website_link: "https://www.gtu.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Academic Excellence",
      subtitle: "Shree Devang Mehta IT Awards, 2017",
      logo_path: "award.png",
      certificate_link:
        "https://photos.app.goo.gl/c8p6B4Z9m1gdfrEp9",
      alt_name: "Shree Devang Mehta IT Awards, 2017",
      color_code: "#8C151599",
    },
    {
      title: "Academic Excellence",
      subtitle: "Shree Devang Mehta IT Awards, 2016",
      logo_path: "award.png",
      certificate_link:
        "https://photos.app.goo.gl/5kNuC8Vd67fmCCEs7",
      alt_name: "Shree Devang Mehta IT Awards, 2016",
      color_code: "#00000099",
    },
    {
      title: "Academic Excellence",
      subtitle: "Shree Devang Mehta IT Awards, 2015",
      logo_path: "award.png",
      certificate_link:
        "https://photos.app.goo.gl/b4e6TA5tJsCcYLY2A",
      alt_name: "Shree Devang Mehta IT Awards, 2015",
      color_code: "#0C9D5899",
    },
    {
      title: "Academic Excellence",
      subtitle: "Parul University, 2014",
      logo_path: "award.png",
      certificate_link:
        "https://photos.app.goo.gl/18Zy3kEmq4aBbkLT6",
      alt_name: "Parul University, 2014",
      color_code: "#1F70C199",
    },
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=0B-kPpJKS_9ekNWFSaTJWTThUN2M",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "CS231n: Computer Vision",
      subtitle: "- Andrej Karpathy",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=0B-kPpJKS_9ekWk5TbGxzT0c2aUU",
      alt_name: "Stanford University",
      color_code: "#D83B0199",
    },
    {
      title: "CS224n: NLP",
      subtitle: "- Christopher D. Manning",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=1K_phGBNfpZ0eN6i9h2Ps6kgnAXjXBg4S",
      alt_name: "Stanford University",
      color_code: "#FFBB0099",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have worked with mature startups and companies as ML/DL Engineer. I've also worked on freelance AI-based projects. Many times I've got the opportunity to help the community through the Guest lecture, Training Program, and workshop.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "AI Engineer, Freelancer",
          company: "root2iot",
          company_url: "https://www.root2iot.com",
          logo_path: "root2iot.png",
          duration: "March 2020 - July 2020",
          location: "India | Remotely",
          description:
            "I have created an AI-based product for facial makeup and hairstyles to virtually try in 3D. Deploy the backend infrastructure with deep learning models and databases in the cloud in a highly scalable way.",
          color: "#9b1578",
        },
        {
          title: "Machine Learning Engineer",
          company: "Formcept",
          company_url: "http://formcept.com",
          logo_path: "formcept.png",
          duration: "Feb 2019 - March 2020",
          location: "Bangalore, India",
          description:
            "I have created the complete infrastructure of the deep learning stack that is useful to developers which, are integrated into MECBot. I've researched, designed, developed, and deployed deep learning models at scale to provide great features. I've developed many NLP and Computer Vision models to provide data analytics that integrated into MECBot. I have created a video analytics platform, NLP toolkit, 3D semi-automatic image annotator, Free-Flow-Search, and many more.",
          color: "#0879bf",
        },
        ,
        {
          title: "Freelancer",
          company: "Self-Employed",
          company_url: "",
          logo_path: "freelancer.png",
          duration: "Nov 2017 - Feb 2019",
          location: "India",
          description:
            "I've worked on NLP and Computer-Vision based projects.",
          color: "#fc1f20",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Machine Learning Research Intern",
          company: "GodsEyeLab",
          company_url: "https://www.facebook.com/GodsEyeLab",
          logo_path: "godseyelab.jpg",
          duration: "January 2018 – June 2018",
          location: "Canada | Remotely",
          description:
            "LSTM based Variational Autoencoder for Text Annotation: This research work focused on Sequential neuron encoding to achieve low dimensional representation of text. The approach shows promising results compared to Unsupervised SVM on the twitter dataset. I've developed API for text-data cleaning, conversion, and analysis. Built a Visual Analysis tool(ConvNet-Vis) for Computer Vision models using Deconvolution, Deep-Dream, and Activation map. I've worked on building 'Lexicocalorimeter' using classical algorithms. Classifying millions of tweets by greedy serial text partitioning and using caloric values of foods and activities, finding health measures of the regions. I've curated the mathematical and proposed system details of 2017-18 publications of Stanford, MIT, and NIPS. Also, I've implemented a few Research papers.",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Experts Talks",
      experiences: [
        {
          title: "Parul University",
          company: "Workshop",
          company_url: "https://twitter.com/g8ghanshym/status/1076456610002808834",
          logo_path: "parul.webp",
          duration: "Dec 2018",
          location: "Vadodara, Gujarat",
          description:
            "Discussed standard procedures in workshop called “Data Science: Application and Practices in Python”.",
          color: "#ee3c26",
        },
        {
          title: "Meditab Software",
          company: "Machine Learning Training",
          company_url: "https://photos.app.goo.gl/n7gfqrKmbgtSbZqVA",
          logo_path: "meditab_logo.png",
          duration: "July 2018",
          location: "Ahmedabad, Gujarat",
          description:
            "Trained Data Conversion and Automation team on “Machine Learning and Deep Learning using TensorFlow and Numpy” for a week.",
          color: "#0879bf",
        },
        {
          title: "AICTE-ISTE",
          company: "Training Program",
          company_url: "https://drive.google.com/drive/folders/1J0gmRJAtqCH6ll4np17WcvIK_JpzYveD?usp=sharing",
          logo_path: "aicte_iste.png",
          duration: "April 2018",
          location: "Bharuch, Gujarat",
          description:
            "Gave an expert session on “Big Data Analytics and Deep Learning” to faculties around Gujarat.",
          color: "#fc1f20",
        },
        {
          title: "IEEE Association",
          company: "Workshop",
          company_url: "https://www.linkedin.com/posts/cg1507_our-student-ghanshyam-chodavadia-cse-parul-activity-6470145926760591360-20s_",
          logo_path: "ieee.png",
          duration: "March 2018",
          location: "Anand, Gujarat",
          description:
            "Invited as a guest lecturer in the workshop for two days on “Data Science & Analytics using Python and Keras”.",
          color: "#0879bf",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Lecturer",
          company: "Parul University",
          company_url: "http://www.paruluniversity.ac.in",
          logo_path: "parul.webp",
          duration: "Oct 2017",
          location: "Vapi, India",
          description:
            "Gave a talk for spreading awareness on “How AI and IoT govern daily life and the ways to be secured on the digital platform” to students of Upasana Lion English Medium School at Vapi.",
          color: "#4285F4",
        },
        {
          title: "Mentor",
          company: "Parul University",
          company_url: "http://www.paruluniversity.ac.in",
          logo_path: "parul.webp",
          duration: "Sep 2017",
          location: "Vadodara, India",
          description:
            "Helped and Guided 5+ teams to think, explore and implement the idea of recent advancement of Artificial Intelligence in the tech expo on the Engineer's Day. Apart from being a technical guide, I was also an organizer of the Engineer's Day events.",
          color: "#D83B01",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "Along with full-time product development, I've worked on open source projects to help/support the AI community. All the projects built with the latest state of the art techniques by the time it developed. Created NLP and Computer-Vision based tools and packages for the data scientist using ML/DL.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "animated_ghanshyam.png",
    description:
      "I am available through following contact mediums. You can message me for any AI-related work, I'll try to answer asap. I can help you with the ML/DL work.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I write blogs to share my learning and knowledge.",
    link: "https://medium.com/@g8ghanshym",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Pennsylvania, USA",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/RdcZxN3afYc1gAs96",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "256.401.7784",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
